export const getters = {
  getEntityDetails(state) {
    return state.entityDetails;
  },
};
